// TODO should this be determined at content load time and see what the longest video is?
export const maxLengthValue = 3900; // 65 minutes, the Max Length slider's top, which means no limit

export interface ContentFilters {
  'License Type': string[];
  'Category': string[];
  'Stressor': string[];
  'Series': string[];
  'Speaker': string[];
  'Media Type': string[];
  'Hide Fully Watched Content': boolean;
  'In Progress': boolean;
  'Max Length': number;
  'CE Credit Eligible': boolean;
  'Text Search': string;
}

export const defaultContentFilters: ContentFilters = {
  'License Type': [],
  'Category': [],
  'Stressor': [],
  'Series': [],
  'Speaker': [],
  'Media Type': [],
  'Hide Fully Watched Content': false,
  'In Progress': false,
  'Max Length': maxLengthValue,
  'CE Credit Eligible': false,
  'Text Search': '',
};

export const allCategories: string[] = [
  'Introduction',
  'The Impact of Diversity, Equity and Inclusion in Medicine',
  'Your First Job',
  'Burnout Basics',
  'Burnout Basics for Nurses',
  'Get Home Sooner',
  'Disaster-Proof Your Leadership Style',
  'Work-life Balance',
  'Leadership Skills for Every Nurse',
  'Leadership Skills: Nurse Leaders',
  'Power Tools',
  'Interprofessional Relationships',
  'Belonging and Bias',
  'Laying the Foundation',
  'Extraordinary Times Survival Guide',
  'Financial Lifecycle of Physicians',
  'Eye of the Storm',
  'Physicians On Purpose Podcast',
  'Healing After Adverse Outcomes',
  'Self-care for the Caregiver',
  'Malpractice Recovery',
  'The Flourishing Nurse Podcast Series',
  'Burnout in Women Clinicians',
  'Compassion Fatigue',
  'Working Nights',
  'Getting Back to the Basics',
];

export const allLicenseTypes: string[] = ['Physicians', 'Nurses', 'Advanced Practice Providers'];
export const allMediaTypes: string[] = ['Video', 'Audio'];

export const SORT_RECOMMENDED = 'Recommended for you';
export const SORT_NEWEST = 'Newest';
export const SORT_MOST_WATCHED = 'Most Watched';
export const SORT_RECENTLY_WATCHED = 'Recently Watched';
export const SORT_SHORT_TO_LONG = 'Time: Short to Long';
export const SORT_LONG_TO_SHORT = 'Time: Long to Short';
export const SORT_OPTIONS = [
  SORT_NEWEST, SORT_MOST_WATCHED, SORT_RECENTLY_WATCHED, SORT_SHORT_TO_LONG, SORT_LONG_TO_SHORT, SORT_RECOMMENDED,
] as const;
export type SortValue = (typeof SORT_OPTIONS)[number];
export const DEFAULT_SORT: SortValue = SORT_RECOMMENDED;

export const UNDER_5_MIN_SECONDS = 300;
export const UNDER_10_MIN_SECONDS = 600;

const ownValue = <V>(record: Readonly<Record<string, V>>, key: unknown): V | undefined =>
  typeof key === 'string' && Object.prototype.hasOwnProperty.call(record, key) ? record[key] : undefined;

/** The License Type tag for a user's license_type. */
export const LICENSE_TAG_BY_TYPE: Readonly<Record<string, string>> = {
  physician: 'Physicians',
  nurse: 'Nurses',
  advanced_practice_provider: 'Advanced Practice Providers',
};

/** null for 'other', null and anything unknown. */
export const licenseTagForType = (licenseType: unknown): string | null => ownValue(LICENSE_TAG_BY_TYPE, licenseType) ?? null;

// The library tags APP lessons with either name, so choosing one has to match both.
const APP_LICENSE_TAGS: readonly string[] = ['Advanced Practice Providers', 'APPs'];

export const LICENSE_TAG_ALIASES: Readonly<Record<string, readonly string[]>> = {
  'Advanced Practice Providers': APP_LICENSE_TAGS,
  'APPs': APP_LICENSE_TAGS,
};

/** The tag names that License Type `values` match: each value and its aliases, deduped, in order. */
export const expandLicenseTags = (values: readonly string[]): string[] =>
  Array.from(new Set(values.flatMap((value) => [value, ...(ownValue(LICENSE_TAG_ALIASES, value) ?? [])])));

export const BROWSE_PATH = '/enrichment_center/browse';

/** Where a "See all" link sends Browse. `sort` null leaves the viewer's current sort alone. */
export interface BrowseTarget {
  filters: Partial<ContentFilters>;
  sort: SortValue | null;
}

/** `filters` over the defaults, so a filter left over from an earlier Browse visit never narrows the list. */
export const browseTarget = (filters: Partial<ContentFilters> = {}, sort: SortValue | null = null): BrowseTarget => ({
  filters: { ...defaultContentFilters, ...filters },
  sort,
});
